"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.rag.name': 'Base de Conocimiento',
    'tools.rag.description': 'Buscar y recuperar información relevante de documentos de la base de conocimiento',
};
